import { render, staticRenderFns } from "./sidebar-group.vue?vue&type=template&id=5467fc44&scoped=true"
import script from "./sidebar-group.vue?vue&type=script&lang=js"
export * from "./sidebar-group.vue?vue&type=script&lang=js"
import style0 from "./sidebar-group.vue?vue&type=style&index=0&id=5467fc44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5467fc44",
  null
  
)

export default component.exports